export default "__VITE_ASSET__67fd9b83__"